import User from "../User";
import WorkflowInstance from "../WorkflowInstance";
import VirtualMachine from "./VirtualMachine";

export default class VirtualMachineRequest {

	id!: number;

	requesterEmail!: string;

	environment!: string;

	resourceGroupName!: string;

	os!: string;

	location!: string;

	subnetName!: string;

	virtualMachineSize!: string;

	osDiskType!: string;

	osDiskSize!: number;

	azureBackup!: string;

	imageReference!: ImageReference;

	patchMode!: string;

	patchSchedule?: string;

	workflowInstance!: WorkflowInstance;

	requesterUser!: User;

	virtualMachines!: VirtualMachine[];

	constructor(obj: any) {
		Object.assign(this, obj);
		this.imageReference = new ImageReference(obj.imageReference);
		this.workflowInstance = new WorkflowInstance(obj.workflowInstance);
	}
}

class ImageReference {

	constructor(obj: any) {
		Object.assign(this, obj);
	}

	publisher!: string;

	offer!: string;

	sku!: string;

	version!: string;
}